import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

const initialState = {
  stateId: { label: "", value: "" },
  districtIds: [],
  stateList: [],
};

export const PractionerRoleIdsSlice = createSlice({
  name: "patientDetails",
  initialState,
  reducers: {
    updateStateId: (state, action: PayloadAction<any>) => {
      state.stateId = action.payload;
    },
    updateDistrictsId: (state, action: PayloadAction<any>) => {
      state.districtIds = action.payload;
    },
    updateStateList: (state, action: PayloadAction<any>) => {
      state.stateList = action.payload;
    },
  },
});

export const { updateStateId, updateDistrictsId, updateStateList } =
  PractionerRoleIdsSlice.actions;
export const selectedStatePractioner = (state: RootState) =>
  state.practionerRoleIds;
export default PractionerRoleIdsSlice.reducer;
